import PageHeader from "../components/PageHeader";
import { TabBar } from "../components/molecules/TabBar";
import { useMenuTitle } from "../shared/menu/useMenuTitle";

const TasksPage = () => {
    const menuTitle = useMenuTitle();
    return (
        <div className="flex-1 flex flex-col overflow-hidden">
            <PageHeader title={menuTitle} />
            <TabBar />
            <div className="flex-1 overflow-auto p-6">
                <div className="text-gray-500">準備中...</div>
            </div>
        </div>
    );
};

export default TasksPage;
